import { Link } from "react-router-dom";
import { comics } from "@/mocks/comics";
import SectionHeading from "./SectionHeading";

export default function PickSection() {
  const sweet = comics.filter((c) => c.category === "甜宠漫画");
  const [featured, ...rest] = sweet;

  return (
    <section className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-14">
          <div>
            <SectionHeading
              align="left"
              eyebrow="编辑力荐"
              title="甜宠精选"
              desc="高甜预警！这些宠溺满满的少女漫，看一话就上头。"
            />
            <Link
              to={`/comic/${featured.id}`}
              className="group relative block aspect-[4/3] overflow-hidden rounded-2xl"
            >
              <img
                src={featured.cover}
                alt={`${featured.title} 甜宠少女漫画封面`}
                title={`${featured.title} 甜宠漫画在线看`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary-950/80 via-primary-950/20 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 flex flex-col gap-2 p-6">
                <span className="w-fit rounded-full bg-accent-500 px-3 py-1 text-xs text-background-50">
                  本周人气TOP
                </span>
                <h3 className="font-heading text-2xl text-background-50">{featured.title}</h3>
                <p className="line-clamp-2 text-sm text-background-50/85">{featured.intro}</p>
                <span className="mt-1 flex items-center gap-1 text-sm text-primary-100">
                  立即开读
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
                </span>
              </div>
            </Link>
          </div>

          <div className="flex flex-col justify-center gap-4">
            {rest.slice(0, 4).map((c, i) => (
              <Link
                key={c.id}
                to={`/comic/${c.id}`}
                className="group flex items-center gap-4 rounded-xl bg-background-100 p-3 transition-colors hover:bg-primary-50"
              >
                <span className="font-heading text-2xl text-primary-300">0{i + 2}</span>
                <div className="h-20 w-14 shrink-0 overflow-hidden rounded-lg">
                  <img
                    src={c.cover}
                    alt={`${c.title} 封面`}
                    className="h-full w-full object-cover object-top"
                  />
                </div>
                <div className="min-w-0 flex-1">
                  <h3 className="line-clamp-1 font-medium text-foreground-900">{c.title}</h3>
                  <p className="mt-1 line-clamp-1 text-sm text-foreground-500">{c.author} · {c.status}</p>
                  <p className="mt-1 text-xs text-foreground-400">已更新 {c.episodes}话</p>
                </div>
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-background-200 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className="ri-arrow-right-line" />
                </span>
              </Link>
            ))}
            <Link
              to="/category/tianchong"
              className="mt-1 flex items-center justify-center gap-1 whitespace-nowrap rounded-xl border border-primary-200 py-3 text-sm text-primary-600 transition-colors hover:bg-primary-50"
            >
              查看更多甜宠漫画
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}